import { Button } from "@softmax/design-system";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { useState } from "react";
import type { CoworldSwitcherState } from "./coworld-switcher-types";

export function CoworldSwitcherStatus({
  state,
  onRetry,
}: {
  readonly state: CoworldSwitcherState;
  readonly onRetry: () => void;
}) {
  const [retryFocused, setRetryFocused] = useState(false);
  const status = state.status === "ready" ? state.refresh : state;
  const failed = status?.status === "error";
  const pending = status?.status === "loading";
  let retryLabel = "Refresh coworlds";

  if (failed) retryLabel = "Try again";
  else if (pending) retryLabel = "Refreshing…";

  return (
    <>
      {pending && (
        <output {...stylex.props(styles.message)}>
          {state.status === "ready" ? "Refreshing…" : "Loading…"}
        </output>
      )}
      {failed && (
        <p role="alert" {...stylex.props(styles.message)}>
          {status.message}
        </p>
      )}
      {(failed || retryFocused) && (
        <Button
          size="sm"
          variant="quiet"
          aria-disabled={pending}
          onFocus={() => setRetryFocused(true)}
          onBlur={() => setRetryFocused(false)}
          onClick={() => {
            if (!pending) onRetry();
          }}
        >
          {retryLabel}
        </Button>
      )}
    </>
  );
}

const styles = stylex.create({
  message: {
    display: "block",
    margin: 0,
    paddingInline: spacing.space12,
    paddingBlock: spacing.space8,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    color: colors.muted,
    fontStyle: "italic",
  },
});
